import { render, staticRenderFns } from "./editMarketSegment.vue?vue&type=template&id=db182746"
import script from "./editMarketSegment.vue?vue&type=script&lang=js"
export * from "./editMarketSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports